import { notifyParent } from 'mailup-react-helpers'
import { PageHeader } from 'mailup-web-components'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'

import setMenuItem from 'Helpers/setMenuItem'

const Header = () => {
  const intl = useIntl()

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Import' }),
    },
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.New' }),
    },
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.New' }),
      isActive: true,
    },
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Status' }),
      onClick: () =>
        notifyParent('redirectMainFrame', [
          'recipients_app_redirector.aspx?r=/recipients/import/status',
        ]),
    },
  ]

  useEffect(() => {
    setMenuItem('RecipientsImportChooseType')
  }, [])

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      title={intl.formatMessage({ id: 'Load.MailupCommon.New' })}
    />
  )
}

export default Header
